import { Component, OnInit } from '@angular/core';
import { _ } from 'underscore';

@Component({
  selector: 'app-get-started',
  templateUrl: './get-started.component.html',
  styleUrls: ['./get-started.component.css']
})
export class GetStartedComponent implements OnInit {

  constructor() { 
    if (!_.isEmpty(localStorage.getItem('userResponse'))) {
      localStorage.removeItem('userResponse');
    }
  }

  ngOnInit() {
  }

}
